export default __webpack_public_path__ + "static/media/lieferheld_l3.e57456ea.png";